import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { StaffAccessService } from '../services/staff-access.service';
import { StaffKey } from '../models/access.model';

/**
 * Guard del eje staff (defensa en profundidad; el API es la autoridad).
 *
 * Uso: { canActivate: [roleGuard, staffGuard], data: { staffPermission: 'access.read' } }
 * Espera a GET /access/me (encadenado después de /auth/me si la sesión viene
 * restaurada). Si falta la clave o /access/me falló, NO cierra la sesión:
 * redirige al aviso de sección cerrada con el motivo.
 */
export const staffGuard: CanActivateFn = (route, state) => {
  const staff = inject(StaffAccessService);
  const router = inject(Router);
  const need = route.data?.['staffPermission'] as StaffKey | undefined;

  if (!need) return true;

  return staff.ensureLoaded().pipe(
    map(() =>
      staff.has(need)
        ? true
        : router.createUrlTree(['/app/access/closed'], {
            queryParams: { need, from: state.url },
          }),
    ),
  );
};
